import { useEffect } from 'react';
import '../App.css';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Helmet } from "react-helmet-async";

// Declare Feathery global type
declare global {
  interface Window {
    Feathery: {
      init: (apiKey: string) => void;
      renderAt: (containerId: string, options: { formId: string }, loginEnabled: boolean) => void;
    };
  }
}

function ContactUs() {
  useEffect(() => {
    // Check if script already exists
    const scriptSelector = 'script[src*="@feathery/react"]';
    let script = document.querySelector(scriptSelector) as HTMLScriptElement;
    
    const initializeForm = () => {
      const container = document.getElementById('feathery-form-container');
      
      if (!container) {
        console.error('Feathery form container not found');
        return;
      }
      
      if (!window.Feathery) {
        console.warn('Feathery is not available yet, retrying...');
        setTimeout(initializeForm, 200);
        return;
      }
      
      try {
        // Clear container first to prevent duplicates (including loading message)
        container.innerHTML = '';
        
        // Initialize Feathery
        window.Feathery.init('649416df-c617-435e-a75a-b8cbe9ed5fdb');
        const loginEnabled = false;
        window.Feathery.renderAt('feathery-form-container', { formId: 'kun4Ie' }, loginEnabled);
        console.log('Feathery form initialized successfully');
      } catch (error) {
        console.error('Error initializing Feathery form:', error);
        // Show error message if form fails to load
        container.innerHTML = '<p style="padding: 20px; color: var(--color-text);">Unable to load form. Please refresh the page or contact us directly.</p>';
      }
    };
    
    if (!script) {
      // Load Feathery script
      script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/@feathery/react@latest/umd/index.js';
      script.async = true;
      script.onerror = () => {
        console.error('Failed to load Feathery script');
      };
      script.onload = () => {
        console.log('Feathery script loaded');
        // Wait a bit for Feathery to be available
        setTimeout(initializeForm, 100);
      };
      document.body.appendChild(script);
    } else {
      // Script already exists
      if (window.Feathery) {
        // Feathery is already available
        initializeForm();
      } else {
        // Script exists but Feathery might not be ready yet
        script.onload = () => {
          setTimeout(initializeForm, 100);
        };
        // Also try after a delay in case script was already loaded
        setTimeout(initializeForm, 500);
      }
    }
    
    // Cleanup
    return () => {
      const container = document.getElementById('feathery-form-container');
      if (container) {
        container.innerHTML = '';
      }
    };
  }, []);

  return (
    <>
    <Helmet>
        <title> Contact Us | Harpwood House Care Home  </title>
        <meta
          name="description"
          content="Contact Harpwood House. Located in Wrotham Heath, Sevenoaks, Kent. Book a tour of our luxury care suites today."
        />
        <link rel="canonical" href="https://www.harpwood.house/contact-us" />
      </Helmet>

    <div className="page">
      <a href="#main-content" className="skip-link">Skip to main content</a>
      <Header />

      <main id="main-content">
        <section className="content-section contact-us-page">
          <div className="contact-us-container">
            <h1>Contact Us</h1>
            
            <div className="contact-layout">
              <section className="contact-form-section">
                <div id="feathery-form-container" className="feathery-form-container">
                  <p style={{ padding: '20px', color: 'var(--color-text)' }}>Loading form...</p>
                </div>
              </section>

              <div className="contact-right-column">
                <section className="contact-section-main">
                  <h2>Phone, e-mail, or write to us, whichever is most convenient:</h2>
                  
                  <div className="contact-details">
                    <div className="contact-address">
                      <p>Harpwood House</p>
                      <p>Seven Mile Lane</p>
                      <p>Wrotham Heath</p>
                      <p>Sevenoaks</p>
                      <p>Kent</p>
                      <p>TN15 7RY</p>
                    </div>

                    <div className="contact-info">
                      <p><strong>Tel:</strong> <a href="tel:01732494555">01732 494 555</a></p>
                      <p><strong>Enquiries:</strong> <a href="mailto:info@harpwood.house">info@harpwood.house</a></p>
                    </div>
                  </div>
                </section>

                <section className="find-us-section">
                  <h2>Find Us</h2>
                  <p>Harpwood House is located in Wrotham Heath, Sevenoaks, Kent.</p>
                  
                  <div className="map-container">
                    <iframe
                      src="https://www.google.com/maps?q=51.297810887800246,0.34535443949212713&output=embed"
                      width="100%"
                      height="450"
                      style={{ border: 0 }}
                      allowFullScreen
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      title="Harpwood House Location"
                      className="google-map-iframe"
                    ></iframe>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
    </>
  );
}

export default ContactUs;

